module.exports = __webpack_public_path__ + "static/img/cuttery.fcbbae3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cuttery.png
// module id = XdL+
// module chunks = 0